import { Search } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Kbd } from '@/components/ui/kbd'
import { Tooltip } from '@/components/ui/tooltip'
import { getConfig } from '@/lib/config'
import { modKeyLabel } from '@/lib/hotkeys'
import { AppScopeSelect } from './AppScopeSelect'
import { Breadcrumbs } from './Breadcrumbs'
import { ThemeToggle } from './ThemeToggle'
import { UserMenu } from './UserMenu'

export function TopBar({ onOpenPalette }: { onOpenPalette: () => void }) {
  const dev = getConfig().authMode === 'dev'
  return (
    <header className="flex h-12 shrink-0 items-center gap-3 border-b border-line bg-surface px-3 md:px-4">
      <AppScopeSelect />
      <div className="h-5 w-px shrink-0 bg-line" aria-hidden />
      <Breadcrumbs className="flex-1" />
      <div className="flex shrink-0 items-center gap-1.5">
        <button
          type="button"
          onClick={onOpenPalette}
          className="flex h-8 cursor-pointer items-center gap-2 rounded-md border border-line-strong bg-surface-2 pr-1.5 pl-2.5 text-sm text-ink-3 transition-colors hover:border-ink-3 hover:text-ink-2 focus-visible:outline-2 focus-visible:outline-focus"
        >
          <Search className="size-4" />
          <span className="hidden lg:inline">Search or jump to…</span>
          <Kbd className="ml-2 hidden sm:inline-flex">{modKeyLabel}K</Kbd>
        </button>
        {dev && (
          <Tooltip content="Development auth: no sign-in. Switch roles from the account menu.">
            <Badge
              tone="warning"
              className="ml-1 cursor-default font-mono tracking-wide"
              tabIndex={0}
            >
              DEV
            </Badge>
          </Tooltip>
        )}
        <ThemeToggle />
        <UserMenu />
      </div>
    </header>
  )
}
